import { backendPy } from "System/system";
import store from "System/reduxStore";

// -------------------------------------------------------
// Get filter stats (master and filtered sizes)
// -------------------------------------------------------
export const getFilterStats = async () => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("filter", "get_stats", {
    projectid: id,
    datapath,
  });
  return result.data;
};


// -------------------------------------------------------
// -------------------------------------------------------
export const addFilter = (filter) => {
  return {
    type: "ADD_FILTER",
    filter,
  };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const removeFilter = (column) => {
  return {
    type: "REMOVE_FILTER",
    column,
  };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const addValue = (column, value) => {
  return {
    type: "ADD_VALUE",
    column,
    value,
  };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const removeValue = (column, value) => {
  return {
    type: "REMOVE_VALUE",
    column,
    value,
  };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const includeAll = (column) => {
  return { type: "INCLUDE_ALL", column };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const excludeAll = (column) => {
  return { type: "EXCLUDE_ALL", column };
};
// -------------------------------------------------------
// -------------------------------------------------------
export const invertFilter = (column) => {
  return { type: "INVERT_FILTER", column };
};

// -------------------------------------------------------
// -------------------------------------------------------
export const getFilterValues = async (header) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("filter", "get_values", {
    projectid: id,
    datapath,
    col: header,
  });

  let all = [];
  if(result.data) {
    all = result.data.values;
  }
  

  const included = JSON.parse(JSON.stringify(all));
  const excluded = [];
  return {
    all,
    included,
    excluded,
  };
};

// -------------------------------------------------------
// -------------------------------------------------------
export const applyFilters = (cb)=> async (dispatch) => {
  const { id, datapath, filters } = store.getState().project;
  const projectid = id;

  const input = [];
  for(const filter of filters) {
    const col = filter.column;
    const values = filter.included;
    input.push({col, values});
  }

  await backendPy("filter", "apply", {
    projectid,
    datapath,
    filters: JSON.stringify(input),
  });

  dispatch({
    type: "CHANGE_FILTER_STATUS",
    filtersHaveChanged: false,
  });
  dispatch({
    type: "CHANGE_REGEX_FILTER_STATUS",
    regexFiltersHaveChanged: true,
  });
  cb();
}

// -------------------------------------------------------
// Apply all filters (binary + regex) together
// -------------------------------------------------------
export const applyAllFilters = (cb) => async (dispatch) => {
  const { id, datapath, filters, regexFilters } = store.getState().project;
  const projectid = id;

  const binaryInput = [];
  for (const filter of filters) {
    const col = filter.column;
    const values = filter.included;
    binaryInput.push({ col, values });
  }

  const regexInput = [];
  for (const filter of regexFilters) {
    const col = filter.column;
    const pattern = filter.pattern;
    regexInput.push({ col, pattern });
  }

  const result = await backendPy("filter", "apply_all", {
    projectid,
    datapath,
    binaryFilters: JSON.stringify(binaryInput),
    regexFilters: JSON.stringify(regexInput),
  });

  dispatch({
    type: "CHANGE_FILTER_STATUS",
    filtersHaveChanged: false,
  });

  if (cb) cb(result.data);
}
